// extracted by mini-css-extract-plugin
module.exports = {"instagram":"SideOptions_instagram__U0DD7"};